import { DEFAULT_CHAT_MODE, normalizeChatMode } from '@/utils/chatMode'
import { normalizeVideoReferenceMediaPreviews } from '@/components/attachment/referenceMedia'

const state = () => ({
  agentId: null,
  conversationId: null,
  conversationInfo: null,
  chatMode: DEFAULT_CHAT_MODE,
  selectedTextAgentId: null,
  preferredImageAgentId: null,
  keyword: '',
  images: [],
  preview_images: [],
  image_references: [],
  imageGenerationContext: null,
  videoGenerationContext: null,
  videoReferenceMediaPreviews: null,
  skillInvocation: null,
  mobileAgentNavigationId: 0,
  mobileAgentNavigation: null,
  mobileAgentNavigationResult: null
})

const getters = {
  agentId: (state) => state.agentId,
  conversationId: (state) => state.conversationId,
  conversationInfo: (state) => state.conversationInfo,
  chatMode: (state) => state.chatMode,
  selectedTextAgentId: (state) => state.selectedTextAgentId,
  preferredImageAgentId: (state) => state.preferredImageAgentId,
  keyword: (state) => state.keyword,
  images: (state) => state.images,
  preview_images: (state) => state.preview_images,
  image_references: (state) => state.image_references,
  imageGenerationContext: (state) => state.imageGenerationContext,
  videoGenerationContext: (state) => state.videoGenerationContext,
  videoReferenceMediaPreviews: (state) => state.videoReferenceMediaPreviews,
  skillInvocation: (state) => state.skillInvocation,
  mobileAgentNavigation: (state) => state.mobileAgentNavigation,
  mobileAgentNavigationResult: (state) => state.mobileAgentNavigationResult
}

const mutations = {
  queueMobileAgentNavigation(state, { agentId, teamId, userId }) {
    const id = ++state.mobileAgentNavigationId
    state.mobileAgentNavigation = { id, agentId, teamId, userId }
    state.mobileAgentNavigationResult = null
  },
  resolveMobileAgentNavigation(state, { id, accepted }) {
    if (state.mobileAgentNavigation?.id !== id) return
    state.mobileAgentNavigation = null
    state.mobileAgentNavigationResult = { id, accepted: accepted === true }
  },
  setChatParams(state, params) {
    state.agentId = params.agentId || null
    state.conversationId = params.conversationId || null
    state.conversationInfo = params.conversationInfo || null
    state.chatMode = normalizeChatMode(params.chatMode)
    state.selectedTextAgentId = params.selectedTextAgentId || null
    state.preferredImageAgentId = params.preferredImageAgentId || null
    state.keyword = params.keyword || ''
    state.images = params.images || []
    state.preview_images = params.preview_images || []
    state.image_references = params.image_references || []
    state.imageGenerationContext = params.imageGenerationContext || null
    state.videoGenerationContext = params.videoGenerationContext || null
    state.videoReferenceMediaPreviews = Array.isArray(params.videoReferenceMediaPreviews)
      ? normalizeVideoReferenceMediaPreviews(params.videoReferenceMediaPreviews) : null
    state.skillInvocation = params.skillInvocation || null
  }
}
const actions = {
  async setChatParams({commit}, params) {
    return new Promise((resolve, reject) => {
      commit('setChatParams', params)
      resolve(true)
    })
  },
  async initChatParams({dispatch}) {
    await dispatch('setChatParams', {
      agentId: null,
      conversationId: null,
      conversationInfo: null,
      chatMode: DEFAULT_CHAT_MODE,
      selectedTextAgentId: null,
      preferredImageAgentId: null,
      keyword: '',
      images: [],
      preview_images: [],
      skillInvocation: null,
      image_references: [],
      imageGenerationContext: null,
      videoGenerationContext: null,
      videoReferenceMediaPreviews: null
    })
  }
}
export default {namespaced: true, state, getters, mutations, actions}
